import { storeAssets } from "../../assets";
import styles from "./styles.module.scss";

const benefits = [
  { icon: storeAssets.benefitGlobal, text: "Mais de 18 anos no mercado global" },
  { icon: storeAssets.benefitSatisfaction, text: "Alto índice de satisfação entre pacientes" },
  { icon: storeAssets.benefitClinic, text: "Clínica especializada em restauração capilar" },
  { icon: storeAssets.benefitShipping, text: "Frete grátis" },
];

export function StoreBenefits() {
  return (
    <section className={styles.section} aria-label="Vantagens da loja">
      <ul className={styles.grid}>
        {benefits.map((benefit) => (
          <li className={styles.item} key={benefit.text}>
            <img src={benefit.icon} alt="" width="32" height="32" loading="lazy" decoding="async" />
            <span>{benefit.text}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
